import styled from "@emotion/styled";
import { FC } from "react";

import {
  DesignToken,
  Icon,
  IconSource,
  RadiusToken,
  SpacingToken,
  Text,
  TransitionDurationToken,
  TransitionTimingToken,
} from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface IProps {
  name: string;
  icon: IconSource;
  premadeType: string;
  disabled?: boolean;
  onClick: () => void;
}

export const AutomationCarouselCard: FC<IProps> = ({ name, icon, premadeType, disabled, onClick }) => {
  return (
    <PremadeRuleContainer
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-testid={`add-btn-premade-${premadeType.toLowerCase().replace(/_/g, "-")}`}
    >
      <Icon source={icon} size="xxlarge" />
      <Text>{name}</Text>
    </PremadeRuleContainer>
  );
};

const PremadeRuleContainer = styled.button`
  appearance: none;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  text-align: start;
  display: flex;
  align-items: center;
  border: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  border-radius: var(${RadiusToken.Radius3});
  gap: var(${SpacingToken.Spacing5});
  padding: var(${SpacingToken.Spacing5});
  width: 260px;
  transition: border-color var(${TransitionDurationToken.Fast2}) var(${TransitionTimingToken.EaseOut});

  &:hover,
  &:active,
  &.highlighted {
    border: 1px ${withVar(DesignToken.BorderBasicHover)} solid;
  }

  &:disabled {
    opacity: 0.5;
  }
  &:disabled:hover {
    border: 1px ${withVar(DesignToken.BorderBasicSecondary)} solid;
  }
`;
